import _ from 'lodash';
import * as functions from '../functions';
import { onChangeFunctionRegex } from '../constants';

/**
 * Hook that returns request function based on its name and given params
 * @param {String} functionName name of the function
 * @returns {[Ojbect, null]} object with function name and returned data or null if not enought data
 */
export default functionName => {
  if (!_.isNil(functionName && functionName.match(onChangeFunctionRegex))) {
    const splitFunction = functionName.split('(');

    return { functionName: splitFunction[0], data: functions[splitFunction[0]](splitFunction[1].replace(/ /g, '').split(')')[0]) };
  }

  return null;
};
